export enum FatcaClassification {
  IGAPartnerJurisdictionFinancialInstitution = 'igaPartnerJurisdictionFinancialInstitution',
  RegisteredDeemedCompliantForeignFinancialInstitution = 'registeredDeemedCompliantForeignFinancialInstitution',
  ParticipatingForeignFinancialInstitution = 'participatingForeignFinancialInstitution',
  PartnerJurisdictionFinancialInstitutionWithoutGIIN = 'partnerJurisdictionFinancialInstitutionWithoutGIIN',
  SponsoredByAanotherEntityOrTrusteeDocumentedTrust = 'sponsoredByAnotherEntityOrTrusteeDocumentedTrust',
  ParticipatingFinancialInstitutionWithoutGIIN = 'participatingFinancialInstitutionWithoutGIIN',
  OwnerDocumentedFinancialInstitution = 'ownerDocumentedFinancialInstitution',
  NonParticipatingFinancialInstitution = 'nonParticipatingFinancialInstitution',
  ExemptBeneficialOwner = 'exemptBeneficialOwner',
  InvestmentEntityWhollyOwnedByExemptBeneficialOwner = 'investmentEntityWhollyOwnedByExemptBeneficialOwner',
  ActiveNonFinancialForeignEntity = 'activeNonFinancialForeignEntity',
  PassiveNonFinancialForeignEntity = 'passiveNonFinancialForeignEntity',
  OwnerDocumentedNFFE = 'ownerDocumentedNFFE',
  DirectReportingNFFE = 'directReportingNFFE',
  SponsoredDirectReportingNFFE = 'sponsoredDirectReportingNFFE',
  SpecifiedUSPersonWithTIN = 'specifiedUsPersonWithTIN',
  NonSpecifiedUSPerson = 'nonSpecifiedUSPerson',

  UsResident = 'UsResident',
  FormerUsResident = 'FormerUsResident',
  NonUsResident = 'NonUsResident',
}

export enum CrsClassification {
  InvestmentEntityNonParticipatingJurisdictionManagedByFI = 'investmentEntityNonParticipatingJurisdictionManagedByFI',
  ReportingFIUnderCRS = 'reportingFIUnderCRS',
  NonReportingFICRSGovernmentalEntity = 'nonReportingFICRSGovernmentalEntity',
  NonReportingFICRSInternationalOrganisation = 'nonReportingFICRSInternationalOrganisation',
  NonReportingFICRSCentralBank = 'nonReportingFICRSCentralBank',
  NonReportingFICRSPensionFundOfGovernmentalEntity = 'nonReportingFICRSPensionFundOfGovernmentalEntity',
  NonReportingFICRSQualifiedCreditCardIssuer = 'nonReportingFICRSQualifiedCreditCardIssuer',
  NonReportingFICRSExemptCollectiveInvestmentVehicle = 'nonReportingFICRSExemptCollectiveInvestmentVehicle',
  NonReportingFICRSTrustTrusteeReportsAllInformation = 'nonReportingFICRSTrustTrusteeReportsAllInformation',
  NonReportingFICRSBroadOrNarrowRetirementFund = 'nonReportingFICRSBroadOrNarrowRetirementFund',
  NonReportingFICRSOther = 'nonReportingFICRSOther',
  ActiveNFEGovernmentalEntity = 'activeNFEGovernmentalEntity',
  ActiveNFEAnyOtherNFE = 'activeNFEAnyOtherNFE',
  PassiveNFE = 'passiveNFE',

  UsResident = 'UsResident',
  FormerUsResident = 'FormerUsResident',
  NonUsResident = 'NonUsResident',
}

export enum FatcaExemptBeneficialOwner {
  ForeignGovernment = 'foreignGovernment',
  InternationalOrganisation = 'internationalOrganisation',
  ForeignCentralBankOfIssue = 'foreignCentralBankOfIssue',
  BroadParticipationRetirementFund = 'broadParticipationRetirementFund',
  NarrowParticipationRetirementFund = 'narrowParticipationRetirementFund',
  GovernmentalRetirementFund = 'governmentalRetirementFund',
  TreatyQualifiedRetirementFund = 'treatyQualifiedRetirementFund',
}
